import { defineStyleConfig } from '@chakra-ui/react';

const Button = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    fontWeight: 'medium',
    borderRadius: 'md',
    transitionProperty: 'background-color, border-color, color, box-shadow',
    transitionDuration: '150ms',
    _focusVisible: {
      boxShadow: 'outline',
      outline: '2px solid',
      outlineColor: 'blue.500',
      outlineOffset: '2px',
    },
  },
  variants: {
    nav: (props) => ({
      bg: 'transparent',
      borderRadius: 'md',
      _hover: { bg: props.colorMode === 'dark' ? 'gray.700' : 'gray.50' },
      _active: { bg: props.colorMode === 'dark' ? 'gray.700' : 'gray.100' },
    }),
    solid: (props) => {
      const { colorScheme: c } = props;

      if (c === 'orange') {
        return { bg: 'brand.blue.500', color: 'white', _hover: { bg: 'brand.blue.600' } };
      }
      if (c === 'blue' || c === 'brand') { // Treat 'brand' as 'blue' for User View
        return { bg: 'brand.blue.500', color: 'white', _hover: { bg: 'brand.blue.600' } };
      }

      // Default solid button style
      return {
        bg: props.colorMode === 'dark' ? 'gray.700' : 'gray.200',
        color: props.colorMode === 'dark' ? 'ink.inverted' : 'ink.primary',
        _hover: { bg: props.colorMode === 'dark' ? 'gray.600' : 'gray.300' },
      }
    },
    ghost: (props) => ({
      _hover: { bg: props.colorMode === 'dark' ? 'gray.700' : 'gray.100' },
    }),
    outline: (props) => {
        const { colorScheme: c } = props;
        const borderColor = props.colorMode === 'dark' ? 'gray.600' : 'gray.200';
        if (c === 'orange' || c === 'red' || c === 'green' || c === 'blue') {
            return { borderColor: `${c}.500` };
        }
        return { borderColor };
    }
  },
  // The default size and variant values
  defaultProps: {
    size: 'md',
    variant: 'solid',
  },
});

export default Button;
